import React from 'react';
import { withRouter } from 'react-router-dom';
import { reduxForm, Field } from 'redux-form';
import { Grid, Divider, Typography } from './../../../../../themes/default';
import { Btn } from './../../../../../components/includes/ui';
import { InputTextField, SelectField, OptionField } from './../../../../../components/includes/ui/input';
import { Buttons, Boxed } from './../../../../../components/includes/container';

import VALIDATION from './../../../../../config/validation';

const validate = values => {

  const errors = {}

  if (!values.text) {
    errors.text = VALIDATION.required;
  }else if(values.text.length > 1024){
    errors.text = 'El máximo de caracteres es 1024.';
  }

  if (values.caption) {
    if(values.caption.length > 1024){
      errors.caption = 'El máximo de caracteres es 1024.';
    }
  }

  if (values.status === '-1') {
    errors.status = VALIDATION.required;
  }

  if (!values.position) {
    errors.position = VALIDATION.required;
  }else if(Number(values.position) <= 0){
    errors.position = 'La posición debe ser mayor a 0.';
  }

  return errors;

};

class BuilderSelectionText extends React.Component {

  componentDidMount(){

  }

  /*
  ** @Submit
  ** @Description: Submit filter form
  */

  handleSubmitForm = (values) => {
    this.props.onSubmit(values);
  }

  /*
  ** @Event
  ** @Description: Cancel
  */

  handleCancel = () => {
    this.props.onCancel();
  }

  render() {

    const { handleSubmit, invalid, selected } = this.props;

    return(

      <form noValidate autoComplete="off" onSubmit={ handleSubmit(this.handleSubmitForm) }>
        <Grid container spacing={24}>

          <Grid item xs={12}>
            <Boxed>
              <Typography variant="h6">
                { selected.title }
              </Typography>
              <Typography>
                { selected.subheader }
              </Typography>
            </Boxed>
          </Grid>

          <Grid item xs={12}>
            <Field
                name="text"
                component={ InputTextField }
                label="Pregunta"
                type="text"
                required
            />
          </Grid>

          <Grid item xs={12}>
            <Field
                name="caption"
                component={ InputTextField }
                label="Aclaración"
                type="text"
            />
          </Grid>

          <Grid item xs={6}>
            <Field
                name="status"
                component={ SelectField }
                label="Requerida"
                required
            >
                  <OptionField key="true" value="true">Si</OptionField>
                  <OptionField key="false" value="false">No</OptionField>
            </Field>
          </Grid>

          <Grid item xs={6}>
            <Field
                name="position"
                component={ InputTextField }
                label="Posición"
                type="number"
                required
            />
          </Grid>

          <Grid item xs={12}>
            <Divider/>
          </Grid>

          <Grid item xs={12}>
            <Buttons align="right">
              <Btn aria-label="Volver" icon="back" color="secondary" onClick={ this.handleCancel }>
                Volver
              </Btn>
              <Btn aria-label="Guardar" icon="save" color="success" type="submit" disabled={ invalid }>
                Guardar
              </Btn>
            </Buttons>
          </Grid>

        </Grid>
      </form>

    )
  }

}

BuilderSelectionText = reduxForm({
  form: 'BuilderSelectionText',
  validate,
  initialValues: {
    status: 'true'
  },
  enableReinitialize: true
})(BuilderSelectionText);

export default withRouter(BuilderSelectionText);
